<template>
  <v-container class="container-page">
    <router-view/>

    <sidebar-contextual :open="openContextualArea" :items-menu="menu" @change="menuClicked" :routeToClose="{ name: 'RecipientIndex' }">
      <template v-slot:default>
        <router-view name="sidebar" />
      </template>

    </sidebar-contextual>

  </v-container>
</template>

<script>
  import SidebarContextual from '@/components/ui/SidebarContextual'
  export default {
    components: { SidebarContextual },
    data () {
      return {
        openContextualArea: false,
        menu: [
          {
            active: false,
            icon: 'info',
            label: 'Informações do Destinatário',
            to: {
              name: 'RecipientShowInfo'
            }
          },
          {
            active: false,
            icon: 'format_list_bulleted',
            label: 'Acompanhe os status',
            to: {
              name: 'RecipientShowTimeline'
            }
          }
        ]
      }
    },
    methods: {
      menuClicked (routeName) {
        this.$router.push({ name: routeName })
      }
    },
    mounted () {
      this.openContextualArea = true
    }
  }
</script>
